module.exports = __webpack_public_path__ + "img/3.f9734e35.svg";